.casaPopoverContent{
    background: rgb(var(--ng-neutral-white));
    width: 260px;
    height: auto;
    max-height: 410px;
    overflow: auto;
    border-radius: var(--ng-rd-6);
    box-shadow: 0px 0px 8px rgba(0,0,0,0.2);
    padding: var(--ng-gp-16);
    outline: none;
}

.triggerWrapper{
    height: 100%;
}

div[data-radix-popper-content-wrapper]:has([class*='casaPopoverContent']){
    z-index: 100 !important;
}